import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../AuthContext'; // <-- IMPORTANT: Make sure this path is correct
import { Spinner, Container } from 'react-bootstrap';

const AdminRoute = ({ children }) => {
    const { user, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) {
        return (
            <Container className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <Spinner animation="border" />
            </Container>
        );
    }

    if (!user) {
        // Not logged in, redirect to login
        return <Navigate to="/prijava" state={{ from: location }} replace />;
    }

    if (user.role !== 'admin') {
        // Logged in but not an admin, redirect to home or an "unauthorized" page
        return <Navigate to="/" replace />;
    }

    // User is an admin, render the requested component
    return children;
};

export default AdminRoute;